var m = require('mithril');
var plainButton = require('../../components/plainButton');

function numericalView(options) {
  var buttonFontSize = '1.2em';
  var numericControlHeight = '5rem';
  var buttonHeight = 'calc((5rem - 0.25rem) / 2)';
  var increment = Number(options.increment) || 1;

  return [
    m('div.flex', {
      style: {
        alignItems: 'stretch',
      },
    }, [
      m('div', {
        style: {
          width: '13.5rem',
          minWidth: '13.5rem',
          maxWidth: '13.5rem',
          marginRight: '0.5rem',
          alignSelf: 'stretch',
        },
      }, [
        m('input.f-headline.h4', {
          style: {
            width: '100%',
            maxWidth: '13.5rem',
            height: numericControlHeight,
            maxHeight: numericControlHeight,
            minHeight: numericControlHeight,
            boxSizing: 'border-box',
          },
          type: 'number',
          oninput: function (ev) { options.onchange(ev.target.value); },
          value: options.value
        })
      ]),
      m('div.flex.flex-column.justify-between', {
        style: {
          width: '6rem',
          minWidth: '6rem',
          maxWidth: '6rem',
          height: numericControlHeight,
          alignSelf: 'stretch',
          gap: '0.25rem',
        },
      }, [
        m(plainButton, {
          label: m('i', {
            style: { fontSize: '1em' },
            class: 'ion-chevron-up',
          }),
          class: '',
          style: {
            width: '6rem',
            maxWidth: '6rem',
            minWidth: '6rem',
            height: buttonHeight,
            minHeight: buttonHeight,
            maxHeight: buttonHeight,
            fontSize: buttonFontSize,
            boxSizing: 'border-box',
          },
          func: function () {
            options.onchange(Number(options.value) + increment);
          }
        }),
        m(plainButton, {
          label: m('i', {
            style: { fontSize: '1em' },
            class: 'ion-chevron-down',
          }),
          class: '',
          style: {
            width: '6rem',
            maxWidth: '6rem',
            minWidth: '6rem',
            height: buttonHeight,
            minHeight: buttonHeight,
            maxHeight: buttonHeight,
            fontSize: buttonFontSize,
            boxSizing: 'border-box',
          },
          func: function () {
            options.onchange(Number(options.value) - increment);
          }
        })
      ])
    ])
  ];
}

function booleanView(options) {
  function renderBooleanToggle(isOn) {
    var touchButtonStyle = {
      width: '7.5rem',
      maxWidth: '7.5rem',
      minWidth: '7.5rem',
      height: '4rem',
      minHeight: '4rem',
      maxHeight: '4rem',
      lineHeight: '4rem',
      fontSize: '1.25rem',
      boxSizing: 'border-box',
    };

    return m('div.flex', [
      m(plainButton, {
        label: 'Off',
        style: Object.assign({}, touchButtonStyle, { marginRight: '0.5rem' }),
        class: isOn ? '' : 'bg-mid-gray',
        func: function () {
          options.onchange(false);
        },
      }),
      m(plainButton, {
        label: 'On',
        style: Object.assign({}, touchButtonStyle, {
          color: isOn ? '#000' : '#fff',
        }),
        class: isOn ? 'bg-blue' : '',
        func: function () {
          options.onchange(true);
        },
      })
    ]);
  }

  return [
    m("div.form-group",[
      renderBooleanToggle(Boolean(options.value)),
      m('br')
    ]),
    m('h3.form-break', ''),
  ];
}

function enumerationView(options) {
  var enumeration = options.pointRecord && options.pointRecord.enumeration || {};
  return [
    m('select.form-control', {
      onchange: function(ev){ options.onchange(ev.target.value); },
      value: options.value,
      style: {
        width: options.fillWidth ? '100%' : undefined,
        minWidth: '16rem',
        minHeight: '4rem',
        fontSize: '1.25rem',
        boxSizing: 'border-box',
      },
    } ,[
      Object.keys(enumeration).map(function(key) {
         return m('option', {value: key }, enumeration[key]);
      })
    ])
  ];
}

module.exports = {
  view: function (vnode) {
    var options = vnode.attrs || {};
    var pointRecord = options.pointRecord || {};

    if (pointRecord.unit === 'bool') {
      return m('div', booleanView(options));
    }

    if (pointRecord.enumeration) {
      return m('div', {
        style: options.fillWidth ? { width: '100%' } : {},
      }, enumerationView(options));
    }

    return m('div', numericalView(options));
  }
};
